module.exports = __webpack_public_path__ + "static/media/plate2-img3.2f615c3f.png";